import avatar from '../assets/images/avatars/skrep1.jpg';
import {profileAPI, usersAPI} from "../api/api";
import {stopSubmit} from 'redux-form';

const ADD_POST = 'ADD-POST';
const SET_USER_PROFILE = 'SET_USER_PROFILE';
const SET_STATUS = 'SET_STATUS';
const DELETE_POST = 'DELETE_POST';
const SAVE_PHOTO_SUCCESS = 'SAVE_PHOTO_SUCCESS';

let initialState = {
	posts: [
		{id: 1, message: 'Hi, how are you?', likesCount: 2, avatarLink: avatar},
		{id: 2, message: 'It\'s my first post', likesCount: 4, avatarLink: avatar},
		{id: 3, message: 'Blabla', likesCount: 3, avatarLink: avatar},
		{id: 4, message: 'Dada', likesCount: 1, avatarLink: avatar}
	],
	profile: null,
	status: '',
};

const profileReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_POST: {
			let newPost = {
				id: 5,
				message: action.newPostText,
				likesCount: 0,
				avatarLink: avatar,
			};
			let stateCopy = {...state};
			stateCopy.posts = [...state.posts];
			stateCopy.posts.push(newPost);
			stateCopy.newPostText = '';
			return stateCopy;
		}
		case SET_STATUS: {
			return {
				...state,
				status: action.status
			};
		}
		case SET_USER_PROFILE: {
			return {...state, profile: action.profile};
		}
		case DELETE_POST:
			return {...state, posts: state.posts.filter(p => p.id !== action.postId)};
		case SAVE_PHOTO_SUCCESS:
			return {...state, profile: {...state.profile, photos: action.photos }}
		default:
			return state;
	}
}

// AC - action creaters
export const addPostActionCreator = (newPostText) => ({type: ADD_POST, newPostText});
export const setUserProfile = (profile) => ({type: SET_USER_PROFILE, profile});
export const setStatus = (status) => ({type: SET_STATUS, status});
export const deletePost = (postId) => ({type: DELETE_POST, postId});
export const savePhotoSuccess = (photos) => ({type: SAVE_PHOTO_SUCCESS, photos});
// AC - action creaters

// thunc creaters
export const getUserProfile = (userId) => async (dispatch) => {
	const response = await usersAPI.getProfile(userId);
	dispatch(setUserProfile(response.data));
}

export const getStatus = (userId) => async (dispatch) => {
	let response = await profileAPI.getStatus(userId);
	dispatch(setStatus(response.data));
}

export const updateStatus = (status) => async (dispatch) => {
	let response = await profileAPI.updateStatus(status);

	if (response.data.resultCode === 0) {
		dispatch(setStatus(status));
	}
}

export const savePhoto = (file) => async (dispatch) => {
	console.log(file)
	let response = await profileAPI.savePhoto(file);

	if (response.data.resultCode === 0) {
		dispatch(savePhotoSuccess(response.data.data.photos));
	}
}

export const saveProfile = (profile) => async (dispatch, getState) => {
	const userId = getState().auth.userId;
	const response = await profileAPI.saveProfile(profile);

	if (response.data.resultCode === 0) {
		dispatch(getUserProfile(userId));
	} else {
		dispatch(stopSubmit("edit-profile", {_error: response.data.messages[0] }));
		return Promise.reject(response.data.messages[0]);
	}
}
// thunc creaters

export default profileReducer;
